// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    
    

    /*
    render function
    */
    import { desCompactImageCellRenderFunction } from 'js/desCompactImageCellService';
    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desCompactImageCellService', () => import('js/desCompactImageCellService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "actions": {
        "render": {
            "method": "desCompactImageCellRenderFunction",
            "deps": "js/desCompactImageCellService"
        }
    },
    "data": {},
    "conditions": {},
    "onEvent": [],
    "lifecycleHooks": {
        "render": "render"
    },
    "props": {
        "vmo": {
            "type": "object"
        }
    },
    "_viewModelId": "DesCompactImageCell",
    "_uniqueViewModelId": "DesCompactImageCell",
    "ctx": {}
};

    


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, desCompactImageCellRenderFunction, undefined, ctxImportObj );

    export default Component;